import { TRANSFER_ORDER_TYPE } from "constants/order";
import React from "react";
import ListTransportLocalities from "./ListTransportLocalities";

const ListTransportLocalitiesReturn = () => {
  return (
    <React.Fragment>
      <ListTransportLocalities orderType={TRANSFER_ORDER_TYPE.RETURN} />
    </React.Fragment>
  );
};

export default ListTransportLocalitiesReturn;
